import querystring from "querystring"
import React, {Component} from "react"
import onClickOutside from "react-onclickoutside"
import {connect} from "react-redux"
import {withRouter} from "react-router-dom"
import ScrollArea from "react-scrollbar"
import {Transition} from "react-transition-group"
import styled from "styled-components"
import infraMonitorService from "../../../api/infraMonitorService"
import CustomDropdown from "../../../components/Dropdown"
import {
    Heading,
    media,
} from "../../../components/styled"
import {images} from "../../../config/index"
import {
    getListSuccess,
    setFilters,
} from "../../../infraMonitor/actions"
import {getProjectsStatsSuccess} from "../../../infraMonitor/projects-stats/actions"
import {
    commonLocalization,
    number,
    projectsLocalization,
} from "../../../localization"
import { projectTypesData, projectStats } from "../../../config/localProjects";

const filterLocalization = {
    en: {
        all: "All",
    },
    np: {
        all: "सबै",
    },
}

class Filter extends Component {
    state = {
        statusValue: "",
        wardValue: "",
        isOpen: false,
        projectType: null,
    }

    componentDidMount() {
        let parsedData = {}
        if (this.props.location.search) {
            parsedData = querystring.parse(
                this.props.location.search.replace("?", ""),
            )

            this.setState({
                wardValue: parsedData.ward ? Number(parsedData.ward) : "",
                statusValue: parsedData.status || "",
                projectType: parsedData["type"] || "",
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.removedFilter !== prevProps.removedFilter) {
            const mapper = {
                status: "statusValue",
                ward: "wardValue",
                "type": "projectType",
            }
            if (mapper[this.props.removedFilter] === "projectType") {
                this.setState({ [mapper[this.props.removedFilter]]: null }, () => {
                    this.props.resetRemovedFilterState();
                });
            } else {
                this.setState({ [mapper[this.props.removedFilter]]: "" }, () => {
                    this.props.resetRemovedFilterState();
                });
            }
        }
    }

    handleDropdownMenu = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    onStatusChange = e => {
        this.setState({statusValue: e.target.value})
    }

    handleProjectTypeChange = value => {
        this.setState({projectType: value})
    }

    handleWardChange = value => {
        this.setState({wardValue: value})
    }

    onFormSubmit = () => {
        const {fiscalYear} = this.props
        this.setState({isOpen: false})
        const {
            statusValue, 
            wardValue, 
            projectType
        } = this.state

        const selectedFilters = {
            "type": projectType,
            ward: wardValue,
            status: statusValue,
            "fiscal-year": fiscalYear,
        }
        this.props.filterData(selectedFilters)
    }

    handleClickOutside = () => {
        if (this.state.isOpen) {
            this.setState({
                isOpen: false,
            })
        }
    }

    getTotalWards = () => {
        const {municipality, municipalities} = this.props
        const currentMunicipality = municipalities.find(
            val => val.name === municipality.title_en,
        )
        return currentMunicipality.no_of_wards
    }

    render() {
        const {selectedLanguage} = this.props
        const localizationCommon = commonLocalization[selectedLanguage]
        const localizationProject = projectsLocalization[selectedLanguage]
        const localizationFilter = filterLocalization[selectedLanguage]

        const projectTypeFilters = projectTypesData.map(type => ({
            value: type.value,
            text: selectedLanguage === "np" ? type.title_ne : type.title_en
        }));

        const totalWards = Array.from(
            {length: this.getTotalWards()},
            (x, i) => ({"value": i + 1, "text": number(i + 1)}),
        )

        return (
            <Dropdown lang={selectedLanguage}>
                <DropdownButton
                    onClick={this.handleDropdownMenu}
                    isOpen={this.state.isOpen}
                >
                    <span className="filter-label"> {localizationProject.filters.title} </span>
                    <span className="icon"/>
                </DropdownButton>

                <Transition in={this.state.isOpen} timeout={100} mountOnEnter>
                    {state => (
                        <DropdownMenu style={{...transitionStyles[state]}}>
                            <FilterBlock>
                                <div>
                                    <span className="remove-keyword remove-filter" onClick={this.handleDropdownMenu}/>
                                    <Heading.h3 uppercase lighter>
                                        {localizationProject.filters.projectType}
                                    </Heading.h3>
                                    <div className="filter-inner-block">
                                        <div className="selection-wrap">
                                            <CustomDropdown 
                                                label={localizationProject.filters.projectType}
                                                value={this.state.projectType}
                                                options={[
                                                    {value: "", text: localizationFilter.all},
                                                    ...projectTypeFilters
                                                ]}
                                                filterType={"projectTypes"}
                                                selectedLanguage={selectedLanguage}
                                                onChange={this.handleProjectTypeChange}
                                            />
                                        </div>
                                    </div>
                                    <Heading.h3 uppercase lighter>
                                        {localizationCommon.wards}
                                    </Heading.h3>
                                    <div className="filter-inner-block">
                                        <div className="selection-wrap">
                                            <CustomDropdown 
                                                label={localizationProject.all}
                                                value={this.state.wardValue}
                                                options={[
                                                    {"value": "", "text": localizationProject.all},
                                                    ...totalWards
                                                ]}
                                                selectedLanguage={selectedLanguage}
                                                filterType={"wards"}
                                                onChange={this.handleWardChange}
                                            />
                                        </div>
                                    </div>
                                    <Heading.h3 uppercase lighter>
                                        {localizationCommon.status}
                                    </Heading.h3>
                                    <div className="filter-inner-block">
                                        <div className="selection-wrap">
                                            <CustomDropdown 
                                                label={localizationCommon.status}
                                                value={this.state.statusValue}
                                                options={projectStats.map(status => ({
                                                    value: status.value,
                                                    text: selectedLanguage === "np" ? status.text_ne : status.text_en
                                                }))}
                                                filterType={"status"}
                                                selectedLanguage={selectedLanguage}
                                                onChange={(value) => this.setState({ statusValue: value })}
                                            />
                                        </div>
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn--ghost"
                                        onClick={this.onFormSubmit}
                                    >
                                        {localizationProject.filters.search}
                                    </button>
                                </div>
                            </FilterBlock>
                        </DropdownMenu>
                    )}
                </Transition>
            </Dropdown>
        )
    }
}

const mapStateToProps = state => ({
    selectedLanguage: state.localizationReducers.selectedLanguage,
    advancedFilters: state.staticData,
    filters: state.infraMonitor.filters,
    fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
    municipalities: state.staticData.municipalities,
})

const mapDispatchToProps = dispatch => ({
    getDataList: filters => {
        infraMonitorService.getProjectList(filters)
            .then(response => {
                dispatch(
                    getListSuccess({
                        projects: response.data,
                        pagination: response.metadata.pagination,
                    }),
                )
                dispatch(setFilters(filters))
            })
        infraMonitorService.getProjectsStatsFiltered(filters)
            .then(response => {
                dispatch(getProjectsStatsSuccess(response))
            })
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(onClickOutside(Filter)))

const FilterBlock = styled.div`
  background-color: var(--color-dark-grey);
  border-radius: 20px;
  box-shadow: var(--shadow-filter-box);
  padding: 20px 34px 24px;
  position: absolute;
  left: 0;
  top: 7px;
  width: 87vw;
  ${media.tabletSmall`width: 374px;left: auto; right: 0;`};
  ${media.tablet`width: 428px;`};
  @media all and (min-width: 992px) and (max-width: 1200px) {
    /* left: 100px; */
    /* right: auto; */
  }
  @media all and (min-width: 992px) {
    left: 0;
    width: 420px;
  }
  @media all and (min-width: 1200px) {
    left: auto;
  }
  @media all and (min-width: 1300px) {
    width: 430px;
  }
  @media all and (min-width: 1400px) {
    width: 480px;
  }

  h3 {
    margin-bottom: 6px;
    small {
      text-transform: uppercase;
    }
  }

  .filter-inner-block {
    border-bottom: 1px solid ${props => props.theme.dark.charcoalGrey};
    padding-bottom: 12px;
    margin-bottom: 11px;
    .selection-wrap {
      margin-left: 0;
    }
    label {
      display: inline-block;
      font-size: 13px;
      margin-bottom: 4px;
      margin-right: 12px;
      padding-left: 16px;
      position: relative;
      input[type="radio"] {
        position: absolute;
        left: 0px;
        top: 50%;
        transform: translateY(-50%);
        width: 12px;
        height: 12px;
        line-height: 32px;
        z-index: 2;
        opacity: 0;
        outline: none;
        &:checked ~ span.radio {
          border-color: ${props => props.theme.primary.pissYellow};
          &:before {
            opacity: 1;
            transition: all 0.3s ease;
          }
        }
      }
      .radio {
        display: inline-block;
        width: 12px;
        height: 12px;
        position: absolute;
        left: 0px;
        top: 5px;
        border: 1px solid var(--color-theme);
        border-radius: 50%;
        &:before {
          content: "";
          position: absolute;
          background-color: ${props => props.theme.primary.pissYellow};
          width: 6px;
          height: 6px;
          border-radius: 50%;
          opacity: 0;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
    & + .btn--ghost {
      margin-top: 12px;
    }
  }

  input[type="radio"] {
    margin-left: 16px;
    margin-right: 4px;
    &:first-child {
      margin-left: 0;
    }
  }

  .ward-dropdown {
    border: 1px solid var(--border-input);
    display: block;
    min-width: 220px;
    border-radius: 3px;
    .title {
      font: ${props => props.theme.fontWeight.medium} 13px
        ${props => props.theme.fontFamily.sansSerif};
      text-transform: none;
    }
  }
`

const Dropdown = styled.span`
  display: block;
  position: relative;
  .filter-label {
    color: var(--color-theme);
    cursor: pointer;
    display: block;
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    padding: ${props =>
    props.lang === "en" ? "11px 11px 11px 21px" : "9px 11px 11px 21px"};
    position: relative;
    text-transform: uppercase;
    &:before {
      background: url(${images.icons.sprite}) no-repeat -55px -38px;
      content: "";
      height: 14px;
      left: 0;
      position: absolute;
      top: 13px;
      width: 16px;
    }
    &:after {
      border-top: 4px solid ${props => props.theme.dark.slateGrey};
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      content: "";
      right: -1px;
      position: absolute;
      top: 18px;
    }
  }
  .scrollarea {
    height: 200px;
  }
  .dropdown-list {
    background: var(--bg-dropdown);
    box-shadow: var(--shadow-dropdown);
    padding: 10px 0;
    border-radius: 4px;
    width: 100%;
    text-align: center;
    li {
      cursor: pointer;
      & + li {
        border-top: 1px solid var(--border-dropdown-color);
        padding-top: 5px;
        font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
      }
    }
  }
  h3 {
    font-size: ${props => (props.lang === "en" ? "11px" : "14px")};
  }

  .filter-inner-block label,
  .ward-dropdown .title {
    font-size: ${props => (props.lang === "en" ? "13px" : "15px")};
  }

  .filter-inner-block label .radio {
    top: ${props => (props.lang === "en" ? "3px" : "6px")};
  }

  .btn--ghost {
    font-size: ${props => (props.lang === "en" ? "14px" : "16px")};
  }
`

const DropdownMenu = styled.div`
  padding-top: 6px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  /* min-width: 184px; */
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: all 0.3s ease-in-out;
  ${media.tabletSmall`left: auto; right: 0;`};
`

const Title = styled.span`
  background: transparent;
  border: 0;
  color: var(--color-theme);
  display: block;
  font: ${props => props.theme.fontWeight.bold}
    ${props => props.theme.fontSize.sm}px
    ${props => props.theme.fontFamily.sansSerif};
  padding: 7px 8px 7px 10px;
  text-transform: uppercase;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`

const DropdownIcon = styled.span`
  border-color: ${props =>
    props.isOpen
        ? "transparent transparent #5D636D"
        : "#5D636D transparent transparent;"};
  border-width: ${props => (props.isOpen ? "0 4px 4px" : "4px 4px 0")};
  border-style: solid;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
`

const DropdownButton = styled.div`
  align-items: center;
  display: flex;
  height: 35px;
  cursor: pointer;
  justify-content: space-between;
`

const transitionStyles = {
    entered: {
        opacity: 1,
        visibility: "visible",
        transform: "translateY(0)",
    },
}


// WEBPACK FOOTER //
// ./src/pages/localProject/list/filter.js